<template>
  <v-container fluid :class="ResponsivePadding">
    <v-layout row wrap class="mx-0">
      <v-flex xs12 sm7>
        <v-layout row wrap>
          <v-flex xs12 sm7>
            <h1 class="display-1 mb-3">
              <span v-if="zeigeversteckte">Versteckte </span>Kundenanfragen
            </h1>
          </v-flex>
          <v-flex xs12 sm5 class="text-xs-right">
            <!-- <v-btn
              icon
              @click="getMeineAnfragen()"
            >
              <v-icon>refresh</v-icon>
            </v-btn> -->

            <v-btn
              flat
              @click="getMeineVerstecktenAnfragen()"
              v-if="!zeigeversteckte"
            >
              Zeige versteckte Anfragen
            </v-btn>
            <v-btn flat @click="getMeineAnfragen()" v-else>
              Zeige Anfragen
            </v-btn>
          </v-flex>
        </v-layout>
        <!-- <h1 class="display-1 mb-3"><span v-if="zeigeversteckte">Versteckte </span>Kundenanfragen
          <v-btn
            icon
            @click="getMeineAnfragen()"
          >
            <v-icon>refresh</v-icon>
          </v-btn>

          <v-btn
            flat
            @click="getMeineVerstecktenAnfragen()"
          >
            Zeige versteckte Anfragen </v-btn>
        </h1> -->
<!-- <div v-if="anfragen">
  <div v-for="anfrage in anfragen.anfragen" :key="anfrage.id" >
    {{ anfrage.id }}
  </div>
</div> -->

        <div v-if="BetriebVorhanden">
          <div v-if="anfragen.anfragen" :class="ResponsivePaddingRechts" class="mt-2">
            <div v-if="!anfragen.anfragen.length > 0">
              <div class="mt-4 subheading">
                <v-icon left>info</v-icon> Aktuell keine Anfragen vorhanden. In diesem Bereich finden Sie persönliche sowie themenbezogene Anfragen.
              </div>
            </div>

            <anfragen-liste
              :anfragen="anfragen.anfragen"
              :zeigeversteckte="zeigeversteckte"
              @anfrageversteckt="versteckeanfrage"
              v-else
            ></anfragen-liste>
          </div>
          <div v-else class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
        <div v-else>
          <v-alert class="mt-3" outline color="info" icon="info" :value="true">
            Kein Betrieb vorhanden, bitte lassen Sie sich verifizieren. <br />
            Anfragen aufgeben können Sie von den Themenseiten aus.
          </v-alert>
        </div>

        <!-- <vue-json-pretty :data="anfragen"></vue-json-pretty> -->
      </v-flex>
      <v-flex xs12 sm5 mt-5>
        <v-tabs
          class="mt-3"
          v-model="active"
          color="accent"
          dark
          slider-color="white"
        >
          <v-tab key="tab1" ripple>
            Ihr Betrieb
          </v-tab>
          <v-tab key="tab2" ripple>
            Einstellungen
          </v-tab>

          <v-tab key="tab3" ripple>
            Informationen
          </v-tab>

          <v-tab-item key="tab1">
            <v-card>
              <v-card-text class="px-4" v-if="this.company">
                <p class="subheading">
                  Ihr Betrieb <strong>{{ this.company.vollername }}</strong> ist mit
                  folgenden Leistungen verknüpft:
                </p>
                <v-layout mt-3 row wrap v-if="anfragen.betrieb">
                  <span
                    v-for="leistung in anfragen.betrieb.leistungen"
                    :key="leistung.id"
                    class="mr-5 my-1"
                  >
                    <v-icon left small>build </v-icon>{{ leistung.leistung }}
                  </span>
                </v-layout>
                <span v-if="anfragen.landingteil">
                  <v-divider class="mt-2" v-if="anfragen.landingteil.length > 0"></v-divider>
                  <p class="mt-3 mb-2 subheading" v-if="anfragen.landingteil.length > 0">
                    Dadurch sind Sie Teil dieser Themenseiten:
                  </p>
                  <v-layout row wrap >
                    <span
                      v-for="landing in anfragen.landingteil"
                      :key="landing.id"
                      class="mr-5 my-1"
                    >
                      <v-icon left small>subject </v-icon>{{ landing.name }}
                    </span>
                  </v-layout>
                </span>
                  <v-divider class="mt-2" v-if="anfragen.landingteil"></v-divider>
                <p class="mt-3 mb-2 subheading">
                  Sie werden aktuell auf der Suche in folgenden Städten
                  gefunden:
                </p>

                <v-layout row wrap>
                  <span
                    v-for="stadt in anfragen.stadtaktiv"
                    :key="stadt.id"
                    class="mr-5 my-1"
                  >
                    <v-icon left small>location_city</v-icon>{{ stadt.name }}
                  </span>

                  <!-- location_city </v-icon>{{ stadt.name }} mit Distanz: {{ stadt.distance | round(1) }} km -->
                </v-layout>

              </v-card-text>
              <v-card-text v-else>
                <v-icon left>info</v-icon> Aktuell kein Betrieb verknüpft.
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="tab2">
            <v-card>
              <v-card-text>
                <h3 class="subheading mb-2">E-Mail Benachrichtigung</h3>
                <p>
                  Wann möchten Sie bei neuen Anfragen benachrichtigt werden?
                </p>

                <v-select
                  class="mx-3"
                  v-model="benachrichtigung"
                  :items="benachrichtigungwahl"
                  label="Zeitpunkt Auswählen"
                  hide-details
                  single-line
                ></v-select>

                <p class="caption mt-4">
                  <v-icon small left color="grey">info</v-icon>
                  Diese Funktion ist aktuell noch deaktiviert.
                </p>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="tab3">
            <v-card>
              <v-card-text>
                <p class="subheading mb-2">Was ist das?</p>
                <p>
                  Dies ist der Betatest des Kundenanfragen-Bereichs. Hier finden
                  Sie potenzielle Auftraggeber mit für Sie relevanten
                  Bedürfnissen. Im Betatest ist diese Funktion auf die
                  Themenseite „Solarmetropole Ruhr“ beschränkt.
                </p>

                <p class="subheading mb-2">Woher kommen die Anfragen?</p>
                <p>
                  Die Anzeigen links sind Anfragen, die von realen potenziellen
                  Auftraggebern über die Themenseiten für die relevanten
                  Innungsbetriebe (Thema und Ort) eingestellt wurden.
                </p>

                <p class="subheading mb-2">Was bedeuten die Symbole?</p>
                <p class="ml-2">
                  <v-icon left>remove_red_eye</v-icon>
                  <span
                    >Anzahl der Nutzer, die die Anfrage angesehen haben.</span
                  >
                </p>

                <p class="ml-2">
                  <v-icon left>mail_outline</v-icon>
                  <span
                    >Anzahl der Nutzer, die die Kundenkontaktdaten gesehen
                    haben.</span
                  >
                </p>

                <p class="ml-2">
                  <v-icon color="grey lighten-1" left>visibility_off</v-icon>
                  <span
                    >Hiermit können Sie irrelevante Anfragen ausblenden.
                  </span>
                </p>

                <p class="subheading mb-2">Was bringt mir das?</p>
                <p>
                  Mit den Informationen können Sie sehen, ob ein Kunde schon
                  mehrmals von Innungskollegen angeschrieben wurde. Wir behalten
                  uns ausserdem vor, Anfragen ab einer bestimmten Anzahl von
                  Kontakten auszublenden.
                </p>

                <p class="subheading mb-2">Wann sind Anfragen beendet?</p>
                <p>
                  Wir moderieren die Anfragen und haken auch beim Kunden nach,
                  ob das Interesse noch besteht. Andernfalls beenden wir die
                  Anfrage.
                </p>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import AnfrageVerstecken from '~/components/anfragen/AnfrageVerstecken.vue'
import AnfragenListe from '~/components/anfragen/AnfragenListe.vue'

export default {
  components: {
    AnfrageVerstecken,
    AnfragenListe
  },
  data () {
    return {
      busy: true,
      company: '',
      benachrichtigung: null,
      benachrichtigungwahl: [
        'Sofort',
        'Täglich',
        'Wöchentlich',
        'Keine Benachrichtigung'
      ],
      icon: 'visibility_off',
      anfragen: [],
      leistungen: '',
      keinbetriebvorhanden: false,
      zeigeversteckte: false,
      active: null,
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  created () {
    // this.getMeinBetrieb()
    // this.getMeineLeistungen()
  },
  mounted () {
    // if (this.BetriebVorhanden) {
    //   if (this.company.length < 1) {
    //     this.getMeinBetrieb()
    //   }
    // }
    this.getMeineAnfragen()
    this.getMeinBetrieb()
  },
  watch: {
    '$route.params': 'anfragereturn'
  },
  computed: {
    ResponsivePadding: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'px-0'
      } else {
        return 'px-3'
      }
    },
    ResponsivePaddingRechts: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'mr-0'
      } else {
        return 'mr-3'
      }
    },
    BetriebVorhanden: function () {
      if (this.$store.getters.authBetrieb) {
        if (this.$store.getters.authBetrieb.name) return true
      }
    }
  },
  filters: {
    round (value, decimals) {
      if (!value) {
        value = 0
      }

      if (!decimals) {
        decimals = 0
      }
      value =
        Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
      return value
    }
  },
  methods: {
    getMeineAnfragen: function () {
      const app = this
      axios
        .get('/api/v1/meineanfragen')
        .then(function (resp) {
          app.anfragen = resp.data
          app.busy = false
          app.zeigeversteckte = false
          // console.log(resp)
        })
        .catch(function (error) {
          console.log('Keine Anfragen:')
          console.log(error)
        })
    },
    getMeineVerstecktenAnfragen: function () {
      const app = this
      axios
        .get('/api/v1/anfragenversteckt')
        .then(function (resp) {
          app.anfragen.anfragen = resp.data.anfragen
          app.busy = false
          app.zeigeversteckte = true
        })
        .catch(function (error) {
          console.log('Keine Anfragen:')
          console.log(error)
        })
    },
    getMeinBetrieb: function () {
      const app = this
      axios
        .get('/api/v1/meinbetrieb')
        .then(function (resp) {
          app.company = resp.data
        })
        .catch(function (error) {
          // console.log('Kein Betrieb verknüpft')
          console.log(error)
        })
    },

    getMeineLeistungen: function () {
      const app = this
      axios
        .get('/api/v1/meineleistung')
        .then(function (resp) {
          app.leistungen = resp.data
        })
        .catch(function (error) {
          // alert("Konnte Firma nicht laden")
          console.log(error)
        })
    },
    anfragereturn () {
      // console.log('shit log:')
      // console.log(this.$route.path.fullPath);
      if (this.$route.path === '/anfragen') {
        // console.log('anfragen refresh')
        this.getMeineAnfragen()
      }
    },
    TrueTransform: function (value) {
      if (value === true) {
        return 'gewünscht'
      } else {
        return value
      }
    },
    versteckeanfrage: function (item) {
      const i = this.anfragen.anfragen.map(item => item.id).indexOf(item.id)
      this.anfragen.anfragen.splice(i, 1)
    }
  },
  metaInfo () {
    return { title: 'Meine Anfragen' }
  }
}
</script>
